// accountDisplay.ts — 勘定科目表示名の解決 (2026-07-09 笠間商事 "(858355854)" incident)
//
// 背景: worker 側の curated pattern parser が md セル「(858355854)」を勘定科目「名」として
// D1 に保存し、proposal detail の accountName に生 ID 文字列 "(858355854)" が素通しで入り、
// 請求書処理ページに ID がそのまま表示された。
// worker 側は build 時に account_items_cache で id/name を相互解決するよう是正済だが、
// UI 側も第二防衛線として「ID 素通し文字列」を検出し、account_items_cache 由来のマップ
// (fetchAccountItemsMap) で名前解決する。未解決時は明示表示にして silent な生 ID 表示を禁止。

/** "(858355854)" / "#858355854" / "858355854" のような ID 素通し文字列から ID を抽出 (それ以外は null) */
export function extractAccountIdFromLabel(label: string | null | undefined): number | null {
  const m = String(label || '').match(/^[#(（]?\s*(\d{6,})\s*[)）]?\s*$/);
  return m ? Number(m[1]) : null;
}

/**
 * 勘定科目の表示名を解決する。
 * - accountName が実名 (ID素通しでない) → そのまま
 * - ID しか無い (accountItemId or ID素通し accountName) → map で名前解決
 * - map 未取得 / 未登録 ID → 「(ID:858355854 — 名前未解決)」の明示表示 (生 ID 素通し禁止)
 */
export function resolveAccountLabel(
  map: Map<number, string> | null,
  accountName: string | null | undefined,
  accountItemId?: number | null,
): string {
  const raw = String(accountName || '').trim();
  const idFromLabel = extractAccountIdFromLabel(raw);
  if (raw && raw !== '—' && idFromLabel === null) return raw; // 実名あり → そのまま
  const id = (accountItemId && Number(accountItemId) > 0) ? Number(accountItemId) : (idFromLabel || 0);
  if (id) {
    const nm = map?.get(id);
    if (nm) return nm;
    return `(ID:${id} — 名前未解決)`;
  }
  return raw || '—';
}
